import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 66px;
  height: 66px;
  position: fixed;
  right: 70px;
  bottom: 45px;
  z-index: 999999;
  border-radius: 50%;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`;

export const ImageButton = styled.img``;